import { Modal } from '../modal/Modal';
import { COLORS } from '../../utils/constants';
import styled from 'styled-components';

export interface ModalSubmitEntityConfirmationProps {
  show?: boolean;
  onClose: () => void;
}

export const ModalSubmitEntityConfirmation = ({ show, onClose }: ModalSubmitEntityConfirmationProps) => {
  return (
    <>
      {show && (
        <Modal onClose={onClose} size={{ height: undefined, width: '40%' }} show={show} title={'Votre entité a bien été soumise !'}>
          <StyledSpan>Nous allons maintenant procéder à la vérification de vos réponses et revenir vers vous au plus vite.</StyledSpan>
        </Modal>
      )}
    </>
  );
};

const StyledSpan = styled.span`
  font-size: 1.2rem;
  color: ${COLORS.Grey};
  line-height: 25px;
`;
